import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner, Alert, ProgressBar, Carousel } from 'react-bootstrap';
import { 
  FaExclamationTriangle, FaCheckCircle, FaClipboardCheck,
  FaTshirt, FaGraduationCap, FaClipboardList, FaUsers,
  FaChartLine, FaPaw, FaStar, FaFilePdf
} from 'react-icons/fa';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router-dom';
import './AdminDashboardCards.css';

// Importar imágenes theriam
import leonjoel from '../../../assets/leonjoel.png';
import pezcadojoel from '../../../assets/pezcadojoel.png';
import ratonjoel from '../../../assets/ratonjoel.png';
import centaurojoel from '../../../assets/centaurojoel.png';
import salchichajoel from '../../../assets/salchichajoel.png';

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

// Data del Theriam Horóscopo
const theriamData = [
  {
    mes: 'Enero - Febrero',
    animal: 'León',
    imagen: leonjoel,
    descripcion: 'El León te llena de valentía y liderazgo',
    mensaje: '🦁 Tu espíritu leonino ruge con fuerza para iniciar el año. La energía del rey de la selva fluye en ti, otorgándote el coraje para enfrentar cualquier desafío. Tu presencia inspira respeto y confianza. Es momento de liderar con determinación, pero recuerda: la verdadera fuerza también reside en la sabiduría.',
    color: '#FF8C00',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    mes: 'Marzo - Abril',
    animal: 'Centauro',
    imagen: centaurojoel,
    descripcion: 'El Centauro equilibra tu fuerza con tu sabiduría',
    mensaje: '🏹 La dualidad del centauro te envuelve en esta primavera. Mitad bestia, mitad sabio, encuentras el balance perfecto entre la acción decidida y el pensamiento estratégico. Tu naturaleza libre te impulsa a explorar nuevos horizontes mientras tu mente aguda te guía. Este es tu momento de armonizar instinto y razón, de galopar hacia tus metas con propósito.',
    color: '#8B4513',
    gradiente: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  },
  {
    mes: 'Mayo - Junio',
    animal: 'Pez',
    imagen: pezcadojoel,
    descripcion: 'El Pez te conecta con tu intuición profunda',
    mensaje: '🐟 Como el pez que navega las profundidades del océano, este periodo te invita a explorar las aguas de tu intuición. Tu sensibilidad está en su punto máximo, permitiéndote percibir lo que otros no ven. Fluye con las corrientes de la vida, adaptándote con gracia. La claridad mental llega cuando te sumerges en la reflexión.',
    color: '#00CED1',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #0072ff 100%)'
  },
  {
    mes: 'Julio - Agosto',
    animal: 'Salchicha',
    imagen: salchichajoel,
    descripcion: 'La Salchicha te recuerda disfrutar con alegría',
    mensaje: '🌭 El espíritu de la salchicha trae consigo la esencia de la satisfacción y el disfrute. Este periodo te enseña que la vida también se trata de celebrar los pequeños placeres. Tu carisma se vuelve irresistible y tu capacidad de hacer felices a los demás alcanza su pico. Comparte tu energía positiva, pero también date el permiso de disfrutar sin culpas. ¡El verano es tuyo!',
    color: '#FF6347',
    gradiente: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
  },
  {
    mes: 'Septiembre - Diciembre',
    animal: 'Ratón',
    imagen: ratonjoel,
    descripcion: 'El Ratón te enseña el valor de los pequeños detalles',
    mensaje: '🐭 El astuto ratón te recuerda que las grandes victorias nacen de pequeños pasos. Tu atención al detalle está afinada, y tu capacidad para encontrar soluciones ingeniosas te distingue. Este ciclo favorece la planificación meticulosa y la paciencia. No subestimes tu poder: a veces, ser pequeño significa ser ágil e imparable. Cierra el año con astucia.',
    color: '#A0A0A0',
    gradiente: 'linear-gradient(135deg, #667eea 0%, #434343 100%)'
  }
];

// Componente del Carrusel Theriam
const TheriamCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Card className="shadow-lg theriam-card" style={{ 
      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
      border: 'none',
      borderRadius: '15px',
      overflow: 'hidden'
    }}>
      <Card.Body className="p-0">
        <div className="text-center py-3" style={{ background: 'rgba(0,0,0,0.2)' }}>
          <h5 className="mb-0 text-white d-flex align-items-center justify-content-center">
            <FaPaw className="me-2" style={{ color: '#FFD700' }} />
            Tu Theriam Místico
            <FaStar className="ms-2" style={{ color: '#FFD700' }} />
          </h5>
          <small className="text-white opacity-75">Descubre tu espíritu animal</small>
        </div>
        
        <Carousel 
          activeIndex={index} 
          onSelect={handleSelect}
          interval={5000}
          className="theriam-carousel"
        >
          {theriamData.map((theriam, idx) => (
            <Carousel.Item key={idx}>
              <div style={{
                background: theriam.gradiente,
                padding: '40px 30px',
                minHeight: '550px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              }}>
                {/* Decoración de estrellas */}
                <div style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '24px',
                  opacity: 0.5
                }}>
                  ✨⭐✨
                </div>
                
                <div className="text-white text-center mb-3" style={{
                  background: 'rgba(0, 0, 0, 0.5)',
                  padding: '15px 30px',
                  borderRadius: '15px',
                  backdropFilter: 'blur(10px)'
                }}>
                  <h2 className="fw-bold mb-2" style={{ 
                    textShadow: '3px 3px 6px rgba(0,0,0,0.7)',
                    fontSize: '36px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.animal}
                  </h2>
                  <p className="mb-0" style={{ 
                    fontSize: '16px',
                    color: '#FFFFFF',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                  }}>
                    {theriam.mes}
                  </p>
                </div>

                <div className="mb-4 theriam-image-container" style={{
                  width: '350px',
                  height: '350px',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  border: '6px solid rgba(255,255,255,0.6)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
                  background: 'white',
                  transition: 'transform 0.3s ease'
                }}>
                  <img 
                    src={theriam.imagen} 
                    alt={theriam.animal}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>

                <div className="text-white text-center px-3" style={{ maxWidth: '700px' }}>
                  <p className="fw-bold mb-3" style={{ 
                    fontSize: '22px', 
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                    background: 'rgba(0, 0, 0, 0.4)',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.descripcion}
                  </p>
                  <p style={{ 
                    fontSize: '15px', 
                    lineHeight: '1.7',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
                    background: 'rgba(0,0,0,0.4)',
                    padding: '20px',
                    borderRadius: '12px',
                    color: '#FFFFFF'
                  }}>
                    {theriam.mensaje}
                  </p>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Card.Body>
    </Card>
  );
};

// Helper para obtener headers de auth
const getAuthHeaders = () => {
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const token = localStorage.getItem('token');
  
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    'x-user-id': String(user?.id || user?.Legajo || user?.CdEmpleado || '1'),
    'x-user-role': String(user?.IdRol || user?.tipoUsuario || '1')
  };
};

const AdminDashboardCards = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estados para cada sección
  const [reclamosStats, setReclamosStats] = useState({ pendientes: 0, resueltos: 0, validados: 0 });
  const [tallesStats, setTallesStats] = useState({ cargados: 0, pendientes: 0 });
  const [capacitacionesCount, setCapacitacionesCount] = useState(0);
  const [colaboradoresCount, setColaboradoresCount] = useState(0);
  const [diagramasCount, setDiagramasCount] = useState(0);
  
  // Obtener legajo del usuario actual
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userLegajo = user?.CdUsuario || user?.Legajo || user?.CdEmpleado || user?.id || null;
  const showTheriam = userLegajo === 43 || userLegajo === '43' || String(userLegajo) === '43';
  
  // Obtener nivel de admin del usuario (AdminLevel 1, 2 o 3)
  const adminLevel = Number(user?.AdminLevel) || 1;
  
  console.log('🎯 Theriam Debug - Legajo:', userLegajo, 'Tipo:', typeof userLegajo, 'Mostrar:', showTheriam);
  
  const RECLAMOS_COLORS = ['#FFC107', '#28A745', '#17A2B8'];

  // Refrescar información del usuario al cargar
  useEffect(() => {
    const refreshUserInfo = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`${API_URL}/api/auth/refresh-user`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success && result.user) {
            // Actualizar localStorage con la info completa del usuario
            localStorage.setItem('user', JSON.stringify(result.user));
            console.log('✅ Usuario actualizado:', result.user);
          }
        }
      } catch (err) {
        console.error('⚠️ Error al refrescar usuario:', err);
      }
    };

    refreshUserInfo();
  }, []);

  useEffect(() => {
    const cargarDashboardStats = async () => {
      try {
        setLoading(true);
        
        const startTime = performance.now();
        console.log('⚡ Fetching optimized dashboard stats...');
        
        // ⚡ UNA SOLA LLAMADA al endpoint optimizado
        const response = await fetch(`${API_URL}/api/stats/dashboard`, {
          headers: getAuthHeaders()
        });
        
        const result = await response.json();
        const elapsed = performance.now() - startTime;
        
        if (result.success && result.data) {
          setReclamosStats({
            pendientes: result.data.reclamos.pendientes,
            resueltos: result.data.reclamos.resueltos,
            validados: result.data.reclamos.validados
          });
          setTallesStats({
            cargados: result.data.talles.cargados,
            pendientes: result.data.talles.pendientes
          });
          setCapacitacionesCount(result.data.capacitaciones.categorias);
          setColaboradoresCount(result.data.empleados.total);          setDiagramasCount(result.data.diagramas.total);          
          console.log(`✅ Dashboard loaded in ${elapsed.toFixed(0)}ms (backend: ${result.meta.queryTimeMs}ms)`);
        } else {
          throw new Error(result.error || 'Error en la respuesta del servidor');
        }
      } catch (err) {
        console.error('❌ Error loading dashboard:', err);
        setError(err.message || 'Error al cargar las estadísticas');
      } finally {
        setLoading(false);
      }
    };

    cargarDashboardStats();
  }, []);

  const reclamosChartData = [
    { name: 'Pendientes', value: reclamosStats.pendientes },
    { name: 'Resueltos', value: reclamosStats.resueltos },
    { name: 'Validados', value: reclamosStats.validados },
  ];

  const totalReclamos = reclamosStats.pendientes + reclamosStats.resueltos + reclamosStats.validados;
  const porcentajeResueltos = totalReclamos > 0 ? Math.round(((reclamosStats.resueltos + reclamosStats.validados) / totalReclamos) * 100) : 0;

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Cargando dashboard...</p>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-4">{error}</Alert>;
  }

  return (
    <div className="admin-dashboard">
      {/* Accesos Rápidos */}
      <Row className="mb-4">
        <Col xs={12}>
          <h5 className="text-muted mb-3">
            <FaChartLine className="me-2" />
            Accesos Rápidos
          </h5>
        </Col>
        {[ 
          { icon: <FaClipboardList size={20} />, title: 'Reclamos', path: '/administrador/reclamos', color: '#FFC107', count: reclamosStats.pendientes, label: 'pendientes', minAdminLevel: 1 },
          { icon: <FaTshirt size={20} />, title: 'Talles', path: '/administrador/talles', color: '#17A2B8', count: tallesStats.cargados, label: 'registros', minAdminLevel: 1 },
          { icon: <FaGraduationCap size={20} />, title: 'Capacitaciones', path: '/administrador/resumen-capacitaciones', color: '#28A745', count: capacitacionesCount, label: 'resumen', minAdminLevel: 1 },
          { icon: <FaUsers size={20} />, title: 'Colaboradores', path: '/administrador/administrar_usuarios', color: '#6F42C1', count: colaboradoresCount, label: 'gestión', minAdminLevel: 1 },
          { icon: <FaFilePdf size={20} />, title: 'Diagramas', path: '/administrador/admin-diagramas', color: '#DC3545', count: diagramasCount, label: 'documentos', minAdminLevel: 2 },
        ]
        .filter(item => item.minAdminLevel <= adminLevel) // Filtrar por nivel de admin
        .map((item, idx) => (
          <Col key={idx} lg={3} md={6} className="mb-3">
            <Card 
              className="h-100 shadow-sm quick-access-card" 
              style={{ cursor: 'pointer', borderLeft: `4px solid ${item.color}` }}
              onClick={() => navigate(item.path)}
            >
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div>
                  <h6 className="text-muted mb-1">{item.title}</h6>
                  <h3 className="mb-0" style={{ color: item.color }}>
                    {typeof item.count === 'number' ? item.count : item.count}
                  </h3>
                  <small className="text-muted">{item.label}</small>
                </div>
                <div style={{ color: item.color, opacity: 0.3 }}>
                  {React.cloneElement(item.icon, { size: 40 })}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Theriam Horóscopo - Solo para usuario 43 */}
      {showTheriam && (
        <Row className="mb-4">
          <Col lg={12}>
            <TheriamCarousel />
          </Col>
        </Row>
      )}

      {/* Sección Reclamos */}
      <Row className="mb-4">
        <Col lg={8}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Row>
                {[
                  { key: 'pendientes', icon: <FaExclamationTriangle />, color: 'warning', label: 'Pendientes' },
                  { key: 'resueltos', icon: <FaCheckCircle />, color: 'success', label: 'Resueltos' },
                  { key: 'validados', icon: <FaClipboardCheck />, color: 'info', label: 'Validados' },
                ].map((item, idx) => (
                  <Col key={idx} md={4} className="text-center mb-3 mb-md-0">
                    <div className={`text-${item.color} mb-2`}>{React.cloneElement(item.icon, { size: 28 })}</div>
                    <h2 className="mb-0">{reclamosStats[item.key]}</h2>
                    <small className="text-muted text-uppercase">{item.label}</small>
                  </Col>
                ))}
              </Row>
              <hr />
              <div className="mt-3">
                <div className="d-flex justify-content-between mb-2">
                  <span>Tasa de resolución</span>
                  <strong>{porcentajeResueltos}%</strong>
                </div>
                <ProgressBar>
                  <ProgressBar variant="success" now={(reclamosStats.resueltos / Math.max(totalReclamos, 1)) * 100} key={1} />
                  <ProgressBar variant="info" now={(reclamosStats.validados / Math.max(totalReclamos, 1)) * 100} key={2} />
                </ProgressBar>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <h6 className="text-center mb-3">Distribución</h6>
              {reclamosChartData.some(item => item.value > 0) ? (
                <div style={{ height: '180px' }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={reclamosChartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={40}
                        outerRadius={70}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {reclamosChartData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={RECLAMOS_COLORS[index % RECLAMOS_COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip formatter={(value) => [`${value}`, 'Cantidad']} />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              ) : (
                <div className="text-center text-muted py-4">Sin datos</div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Sección Talles */}
      <Row>
        <Col lg={6}>
          <Card className="shadow-sm">
            <Card.Header className="bg-info bg-opacity-10">
              <h6 className="mb-0">
                <FaTshirt className="me-2 text-info" />
                Registro de Talles
              </h6>
            </Card.Header>
            <Card.Body className="text-center">
              <div className="d-flex justify-content-center align-items-center">
                <div className="me-4">
                  <FaUsers size={48} className="text-info opacity-50" />
                </div>
                <div>
                  <h2 className="mb-0 text-info">{tallesStats.cargados}</h2>
                  <span className="text-muted">Colaboradores con talles registrados</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={6}>
          <Card className="shadow-sm h-100">
            <Card.Header className="bg-secondary bg-opacity-10">
              <h6 className="mb-0">
                <FaChartLine className="me-2 text-secondary" />
                Resumen General
              </h6>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span>Total Reclamos</span>
                <strong>{totalReclamos}</strong>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span>Pendientes</span>
                <strong className="text-warning">{reclamosStats.pendientes}</strong>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span>Resueltos</span>
                <strong className="text-success">{reclamosStats.resueltos}</strong>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2">
                <span>Talles Cargados</span>
                <strong>{tallesStats.cargados}</strong>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboardCards;